import { Avatar } from "@mui/material";
import "../../../assets/styles/components/CardColorStyle.css";
import AssignmentIcon from "@mui/icons-material/Assignment";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import {
    c_primary,
    c_primary_l,
    c_disabled,
    dashboard_blue,
    dashboard_blue_soft,
    stat_coupon_header,
    stat_coupon_accent,
    stat_coupon_title,
} from "../../../utils/constants/ColorConst";

function avatarIconColor(accent, titleColor) {
    if (String(accent).toLowerCase() === "#f7df5b") {
        return titleColor ?? stat_coupon_title;
    }
    return "#fff";
}

function ColorCard({
    title,
    description,
    list,
    rightEnd,
    headerBg: headerBgProp,
    accentColor: accentProp,
    titleColor: titleColorProp,
    blueCard,
    yellowCard,
    iconCard,
    onclickCard,
    disabledIconLi,
    centerDesc,
    smallCard,
    bloqued,
}) {
    let headerBg;
    let accent;
    let titleColor;

    if (bloqued) {
        headerBg = "#F3F4F6";
        accent = "#9ca3af";
        titleColor = c_disabled;
    } else if (yellowCard) {
        headerBg = stat_coupon_header;
        accent = stat_coupon_accent;
        titleColor = titleColorProp ?? stat_coupon_title;
    } else if (blueCard) {
        headerBg = dashboard_blue_soft;
        accent = dashboard_blue;
        titleColor = titleColorProp ?? dashboard_blue;
    } else {
        headerBg = headerBgProp ?? c_primary_l;
        accent = accentProp ?? c_primary;
        titleColor = titleColorProp ?? accent;
    }

    const listIconColor = bloqued ? c_disabled : accent;

    return (
        <div
            className={
                smallCard
                    ? "content-card-color-small"
                    : bloqued
                      ? "content-card-color-bloqued"
                      : "content-card-color"
            }
            onClick={onclickCard}
        >
            <div className="header-card-color" style={{ backgroundColor: headerBg }}>
                <span className="text-card-color-title" style={{ color: titleColor }}>
                    {title}
                </span>
                <Avatar
                    className="avatar-color-card"
                    sx={{
                        backgroundColor: accent,
                        color: bloqued ? "#fff" : avatarIconColor(accent, titleColor),
                    }}
                >
                    {iconCard ? iconCard : <AssignmentIcon />}
                </Avatar>
            </div>
            <div className={centerDesc ? "center-desc" : "content-color-card"}>
                <span className="text-description-card-color">{description}</span>
                <ul
                    className={
                        disabledIconLi ? "list-description-colum" : "ul-list-description-card"
                    }
                >
                    {list
                        ? list.map((item, idx) => {
                              return (
                                  <li key={idx} className="list-description-card-color">
                                      {disabledIconLi ? null : (
                                          <TaskAltOutlinedIcon
                                              fontSize="small"
                                              sx={{ mr: 1, color: listIconColor }}
                                          />
                                      )}
                                      <span className="text-description-card-color">{item}</span>
                                  </li>
                              );
                          })
                        : null}
                </ul>
                <div className="foter-description-card">{rightEnd}</div>
            </div>
        </div>
    );
}

export default ColorCard;
